import { serviceName } from '../resources/serviceConstants';
import { AUDIT_LOGIN, LOGOUT, VERIFY_ACCESS_TOKEN } from '../resources/endPoint';

export const loginAudit = (data) => {
  // API call to insert user details to audit user login

  return {
    url: AUDIT_LOGIN,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.LANDING_MS,
  };
};

export const verifyAccessToken = (token) => {
  return {
    url: VERIFY_ACCESS_TOKEN,
    method: 'get',
    headers: {
      'content-type': 'application/json',
      token: token,
      isAuthToken: true,
    },
    authRequired: false,
    csrfToken: true,
    service: serviceName.LANDING_MS,
  };
};

export const expireToken = (token) => {
  // API call to expire token

  return {
    url: LOGOUT,
    method: 'post',
    headers: {
      'content-type': 'application/json',
      isAuthToken: true,
    },
    authRequired: false,
    csrfToken: true,
    payload: { token },
    service: serviceName.LANDING_MS,
  };
};
